import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { Highlight, Info } from 'components/Common';

export const AccountInformation = ({ t, customer }) => (
  <div className="layout__section">
    <h2>{t('account.information.heading')}</h2>

    <p>{t('account.information.description')}</p>

    <Highlight clear>
      <Info>
        <Info.Title>{t('account.information.name')}</Info.Title>
        <Info.Content>{customer.name}</Info.Content>
      </Info>
      <Info>
        <Info.Title>{t('account.information.email')}</Info.Title>
        <Info.Content>{customer.email}</Info.Content>
      </Info>
      <Info clear>
        <Info.Title>{t('account.information.phone')}</Info.Title>
        <Info.Content>{customer.primaryPerson.phonenumber}</Info.Content>
      </Info>
    </Highlight>
  </div>
);

AccountInformation.propTypes = {
  t: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired
};

export default translate()(AccountInformation);



// WEBPACK FOOTER //
// ./src/components/AccountInformation/AccountInformation.js